import React from "react";
import {Button, Checkbox, Col, Dropdown, Menu, Modal, Row, Spin} from "antd";
import {ChevronRightIcon, DiamondIcon, FlameIcon, KeyIcon} from "@components/icons/Icons";
import {EllipsisOutlined, SyncOutlined, WarningOutlined} from "@ant-design/icons";
import {formatDateTiny, formatNumber} from "@lib/format";
import BookCover from "@components/book-cover";
import {FmvPrice} from "@components/fmv-price";

const MyCollectionSeriesListItemMobile = ({
  series,
  showEditMultiple,
  isSelected,
  toggleSelected,
  navigate,
  hasIcons,
  postRefreshFmv,
  showTotalFmv,
  refreshFmvResponse,
  fmvUpdated,
  removeSeriesFromCollection,
}) => {
    return (
        <Row className="grid-list-item">
            {showEditMultiple && (
                <Col className="col-cbx">
                    <Checkbox
                        checked={isSelected}
                        onChange={() => toggleSelected(series.series_id)}
                    />
                </Col>
            )}
            <div >
                <div className="col-image">
                    <a href={'/series-issues?view='+series.series_id}>
                        <BookCover className="list-book-cover" issue={series} preview={false} />
                    </a>
                </div>
            </div>

            <div className="grid-list-content-small-screen">
                <Row>
                    <Col span={12} className="flex-row">
                        {hasIcons && (
                            <div className="valueBadges" >
                                {series.overview.items_key > 0 && (<span className="pad-right-5"><div className="valueBadge keyIssue isActive"><KeyIcon /></div> ({series.overview.items_key})</span>)}
                                {series.overview.items_hot > 0 && (<span className="pad-right-5"><div className="valueBadge hotIssue isActive"><FlameIcon /></div> ({series.overview.items_hot})</span>)}
                                {series.overview.items_rare > 0 && (<span className="pad-right-5"><div className="valueBadge rareIssue isActive"><DiamondIcon /></div> ({series.overview.items_rare})</span>)}
                            </div>
                        )}
                    </Col>
                    <Col span={12} className="no-wrap">
                        <div className="col-right">
                            <Dropdown className="greyButton selectButton" trigger={["click"]} overlay={(
                            <Menu >
                                {/*<Menu.Item key={1} disabled >Mark All As Sold</Menu.Item>*/}
                                <Menu.Item key={2}
                                           onClick={() => Modal.confirm({
                                               autoFocusButton: null,
                                               icon: <WarningOutlined />,
                                               content: (<div>
                                                   <div><b>Delete Series</b></div>
                                                   <div className="pad-top-10">
                                                       Are you sure?<br/>
                                                       Selecting this option will delete these series permanently. This action cannot be undone.
                                                   </div>
                                               </div>),
                                               onOk() {
                                                   removeSeriesFromCollection({series_ids: [series.series_id]});
                                               },
                                           })}
                                >Delete Series</Menu.Item>
                                <Menu.Item key={3}><a href={series.series_permalink}>Go To Full Series</a></Menu.Item>
                                {/*<Menu.Item key={3} disabled>Mark all listed for sale</Menu.Item>*/}
                                {/*<Menu.Item key={4} disabled>add to pull list</Menu.Item>*/}
                            </Menu>
                        )}>
                            <Button className="greyButton mar-left-5" size={"small"}>
                                <EllipsisOutlined className="font-12 iconDarkGrey" />
                            </Button>
                        </Dropdown>

                        <Button
                            type="text"
                            className="pad-0-10"
                            href={'/series-issues?view='+series.series_id}
                        >
                            <ChevronRightIcon className="icon24 iconGrey"/>
                        </Button>
                        </div>
                    </Col>
                </Row>
                <Row className="item-title">
                    <Col span={24} className="flex-col">
                        <div className="break-spaces">
                            <div className="cursor-pointer titleLink font-16" onClick={() => { navigate('series-issues?view='+series.series_id); }}>
                                {series.series_title}
                            </div>
                            <div className="font-12 font-normal">
                                {series.publisher} | {series.year_began}
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="font-12">
                    <Col span={24}>
                        <div className={"greyPill pad-left-10 pad-right-10 pad-5 font-16"}>
                            Total FMV
                            <span className="float-right text-grey font-normal">
                                Qty: {formatNumber(series.overview.items)}
                            </span>
                        </div>
                    </Col>
                </Row>

                <Spin spinning={refreshFmvResponse.isLoading}>
                    <Row className="pad-top-5 pad-left-10">
                        <Col span={12} className="flex-col">
                            {showTotalFmv ? (
                                <>
                                    <FmvPrice
                                        value={series.fmv}
                                        stale={series.fmv_is_stale}
                                        staleInfo="FMV data is stale, please update."
                                    />
                                    {(series.fmv_can_update && fmvUpdated) && (
                                       <span className='font-10 text-grey'>Updated: {formatDateTiny(fmvUpdated)}</span>
                                    )}
                                </>
                            ):(
                                <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                            )}
                        </Col>
                        <Col span={12}
                             className={'flex-vertical-center flex-align-right pad-right-10 ' + (series.fmv_can_update ? ' cursor-pointer ' : '')}
                             onClick={(showTotalFmv && series.fmv_can_update) ? async () => {
                                 await postRefreshFmv({series_id: series.series_id})
                             } : undefined}
                        >
                            {series.fmv_can_update && (<SyncOutlined className={'fmv-update can-update'} />)}
                        </Col>
                    </Row>
                </Spin>
            </div>
        </Row>
    );

};

export default MyCollectionSeriesListItemMobile;